import { mount } from 'svelte';
import App from './App.svelte';
import { t } from '$core/i18n';
import { db } from '$db/local/db';
import { runMigrations } from '$db/local/migrations';
import { bootstrapIdentity, identity } from '$core/identity';
import { isSupabaseConfigured } from '$db/remote/supabase';
import { installDevTools } from '$core/dev/tools';
import { installBridge, withSuppression } from '$db/local/repositories';

import { registerPwa } from '$core/pwa/register';
import { applyInitialTheme } from '$core/preferences';

applyInitialTheme();

document.title = t('app.title');

registerPwa({
  onNeedRefresh: () => {
    console.info('[StudyQuantifier] Nueva versión disponible. Recarga para aplicar.');
  },
  onOfflineReady: () => {
    console.info('[StudyQuantifier] PWA lista para uso offline.');
  },
  onRegisterError: (err) => {
    console.warn('[StudyQuantifier] Fallo al registrar service worker:', err);
  }
});

async function bootstrap() {
  try {
    await db.open();
    await withSuppression(async () => {
      await runMigrations(db);
    });
    installBridge();
    console.info(
      '[StudyQuantifier] DB ready. Stores:',
      db.tables.map((tb) => tb.name).join(', ')
    );

    if (!isSupabaseConfigured()) {
      console.info(
        '[StudyQuantifier] Supabase not configured. Local-only mode.'
      );
    }

    await bootstrapIdentity();
    console.info(
      `[StudyQuantifier] Identity: ${identity.identity.kind} (${identity.identity.userId})`
    );

    if (import.meta.env.DEV) {
      installDevTools();
    }
  } catch (err) {
    console.error('[StudyQuantifier] Bootstrap failed:', err);
  }
}

const target = document.getElementById('app');
if (!target) {
  throw new Error('Root element #app not found in index.html');
}

const rootTarget: HTMLElement = target;

let app: ReturnType<typeof mount> | null = null;

async function start() {
  await bootstrap();
  app = mount(App, { target: rootTarget });
}

void start();

export default app;